import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
import ShopNameImg from '../../../assets/images/rn/FoodShop';
import BuyerInfoImg from '../../../assets/images/rn/FoodBuyer';
import { FONT_WEIGHT_MEDIUM, FONT_WEIGHT_REGULAR } from '../../../styles/rn';
export var BannerType;
(function (BannerType) {
  BannerType["OrderCode"] = "orderCode";
  BannerType["CreateTime"] = "createTime";
})(BannerType || (BannerType = {}));
export var FoodOrder = function FoodOrder(props) {
  var _props$bannerType = props.bannerType,
    bannerType = _props$bannerType === void 0 ? BannerType.OrderCode : _props$bannerType,
    status = props.status,
    shopName = props.shopName,
    buyerInfo = props.buyerInfo,
    orderCode = props.orderCode,
    createTime = props.createTime,
    wrapperStyle = props.wrapperStyle,
    bannerStyle = props.bannerStyle,
    componentTrackingData = props.componentTrackingData,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {
      return null;
    } : _props$onClick;
  var _useComponentTracking = useComponentTracking({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    panelOrderTracking = _useComponentTracking.result.panelOrder;
  var onOrderClick = function onOrderClick() {
    // 点击埋点
    (panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingClick) && tracker.click(panelOrderTracking.trackingClick);
    onClick === null || onClick === void 0 ? void 0 : onClick({
      data: props
    });
  };
  return /*#__PURE__*/React.createElement(Pressable, _extends({
    style: [styles['food-order-container'], wrapperStyle],
    onPress: onOrderClick
  }, panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingImpressionProps), /*#__PURE__*/React.createElement(View, {
    style: [styles['food-order-banner'], styles["food-order-banner-".concat(bannerType)], bannerStyle]
  }, bannerType === BannerType.OrderCode && /*#__PURE__*/React.createElement(Text, {
    style: styles['food-order-banner-code'],
    numberOfLines: 1
  }, "#", orderCode), bannerType === BannerType.CreateTime && /*#__PURE__*/React.createElement(Text, {
    style: styles['food-order-banner-create-time'],
    numberOfLines: 1
  }, createTime), /*#__PURE__*/React.createElement(Text, {
    style: styles['food-order-banner-status'],
    numberOfLines: 1
  }, status)), /*#__PURE__*/React.createElement(View, {
    style: styles['food-order-content']
  }, /*#__PURE__*/React.createElement(View, {
    style: styles['food-order-content-shop-name']
  }, /*#__PURE__*/React.createElement(View, {
    style: styles['food-order-content-shop-name-icon-container']
  }, /*#__PURE__*/React.createElement(ShopNameImg, {
    style: styles['food-order-content-shop-name-icon']
  }), /*#__PURE__*/React.createElement(View, {
    style: [styles['food-order-content-shop-name-icon-after'], {
      transform: [{
        translateX: 10
      }, {
        translateY: 12
      }]
    }]
  })), /*#__PURE__*/React.createElement(Text, {
    style: styles['food-order-content-shop-name-text'],
    numberOfLines: 1
  }, shopName)), /*#__PURE__*/React.createElement(View, {
    style: styles['food-order-content-buyer-info']
  }, /*#__PURE__*/React.createElement(BuyerInfoImg, {
    style: styles['food-order-content-buyer-info-icon']
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles['food-order-content-buyer-info-text'],
    numberOfLines: 3
  }, buyerInfo))));
};
var styles = CustomStyleSheet({
  'food-order-container': {
    width: '100%',
    backgroundColor: '#ffffff'
  },
  'food-order-banner': {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 14,
    paddingHorizontal: 12,
    backgroundColor: '#fafafa',
    borderBottomWidth: 0.5,
    borderStyle: 'solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.09)'
  },
  'food-order-banner-code': _objectSpread(_objectSpread({
    margin: 0
  }, FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 16,
    lineHeight: 20,
    color: '#ee4d2d',
    maxWidth: '70%'
  }),
  'food-order-banner-create-time': _objectSpread(_objectSpread({
    margin: 0
  }, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 16,
    lineHeight: 20,
    color: 'rgba(0, 0, 0, 0.54)',
    maxWidth: '70%'
  }),
  'food-order-banner-status': _objectSpread(_objectSpread({
    margin: 0,
    marginLeft: 'auto'
  }, FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.65)',
    maxWidth: '30%'
  }),
  'food-order-banner-createTime': {
    backgroundColor: '#ffffff'
  },
  'food-order-content': {
    padding: 12
  },
  'food-order-content-shop-name': {
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  'food-order-content-shop-name-icon-container': {
    position: 'relative'
  },
  'food-order-content-shop-name-icon': {
    flexShrink: 0,
    width: 20,
    height: 20
  },
  'food-order-content-shop-name-icon-after': {
    width: 2,
    height: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.09)',
    position: 'absolute',
    left: '50%',
    bottom: 0
  },
  'food-order-content-shop-name-text': _objectSpread(_objectSpread({
    margin: 0,
    marginLeft: 12
  }, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  }),
  'food-order-content-buyer-info': {
    marginTop: 16,
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  'food-order-content-buyer-info-icon': {
    flexShrink: 0,
    position: 'relative',
    width: 20,
    height: 20
  },
  'food-order-content-buyer-info-text': _objectSpread(_objectSpread({
    margin: 0,
    marginLeft: 12
  }, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  })
});